import { useCallback, useEffect, useState } from 'react';
import Molten from '@leverege/molten';
import { GlobalState } from '@leverege/ui-redux';
import parseFetchConfigurationsResponse from './parseFetchConfigurationsResponse';
const useDeviceAndStateConfigOptions = ({
  sku,
  locationIds,
  placeHolder,
  server
}) => {
  const [loading, setLoading] = useState(false);
  const [deviceConfigurationOptions, setDeviceConfigurationOptions] = useState([]);
  const [stateConfigurationOptions, setStateConfigurationOptions] = useState([]);
  const [currentKeystreamIds, setCurrentKeystreamIds] = useState([]);
  const [locations, setLocations] = useState([]);
  const fetchConfigurations = useCallback(async () => {
    const systemId = Molten.getConfig('api/systemId');
    const r4kEnabled = Molten.getConfig('r4kEnabled') === 'true';
    let responseSkus;
    if (server === 'recovr') {
      const {
        items
      } = await GlobalState.dispatch(async (dispatch, getState, {
        api
      }) => api.system(systemId).srv('recovr').get(`config?sku=${sku}`));
      responseSkus = {
        items
      };
    }
    if (r4kEnabled && server === 'kudelskidevice') {
      const {
        items
      } = await GlobalState.dispatch(async (dispatch, getState, {
        api
      }) => api.system(systemId).srv('kudelskidevice').get(`config?sku=${sku}`));
      responseSkus = {
        items
      };
    }
    const {
      items
    } = await GlobalState.dispatch((dispatch, getState, {
      api
    }) => api.interface(systemId, 'location').search({
      filter: {
        field: 'id',
        type: 'equals',
        value: locationIds
      }
    }));
    setLocations(items);
    const {
      deviceConfigurations,
      stateConfigurations
    } = parseFetchConfigurationsResponse(responseSkus);
    setDeviceConfigurationOptions([placeHolder, ...deviceConfigurations]);
    setStateConfigurationOptions([placeHolder, ...stateConfigurations]);
  }, [sku]);
  const getCurrentKeystreamIdsForAllLocations = useCallback(() => {
    const formattedSku = sku.replaceAll(/[-\\.]/ig, '_');
    const currentDeviceSpecificKeystreamIds = locations.map(location => location?.data?.config?.[formattedSku]?.desiredDeviceSpecific?.keystreamId);
    const currentStateSpecificKeystreamIds = locations.map(location => location?.data?.config?.[formattedSku]?.desiredStateSpecific?.keystreamId);
    const isAllTheSameDeviceConfig = currentDeviceSpecificKeystreamIds.every((val, i, arr) => val === arr[0]);
    const isAllTheSameStateConfig = currentStateSpecificKeystreamIds.every((val, i, arr) => val === arr[0]);
    const currentKeystreamIds = [];
    if (isAllTheSameDeviceConfig && currentDeviceSpecificKeystreamIds?.[0]) {
      currentKeystreamIds.push(currentDeviceSpecificKeystreamIds?.[0]);
    }
    if (isAllTheSameStateConfig && currentStateSpecificKeystreamIds?.[0]) {
      currentKeystreamIds.push(currentStateSpecificKeystreamIds?.[0]);
    }
    setCurrentKeystreamIds(currentKeystreamIds);
  }, [locations, sku]);
  const loadData = async () => {
    setLoading(true);
    await fetchConfigurations();
    setLoading(false);
  };
  useEffect(() => {
    loadData();
  }, []);
  useEffect(() => {
    if (locations.length > 0) {
      getCurrentKeystreamIdsForAllLocations();
    }
  }, [locations]);
  return {
    loading,
    locations,
    deviceConfigurationOptions,
    stateConfigurationOptions,
    currentKeystreamIds
  };
};
export default useDeviceAndStateConfigOptions;